var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoginIcon = function SvgLoginIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffb657;}.b,.c,.e{fill:none;}.b{stroke:#1a295b;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.c{stroke:#ffb657;stroke-width:2px;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1600 -48)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1605 53)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1604 51.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.436,27.081V25.554A3.218,3.218,0,0,0,16.077,22.5H9.359A3.218,3.218,0,0,0,6,25.554v1.527",
    transform: "translate(0 -7.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.108,7.554A3.054,3.054,0,1,1,15.054,4.5,3.054,3.054,0,0,1,18.108,7.554Z",
    transform: "translate(-2.336 2)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(1600 48)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 17,
    cy: 17,
    r: 16
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoginIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNCIgaGVpZ2h0PSIzNCIgdmlld0JveD0iMCAwIDM0IDM0Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZiNjU3O30uYiwuYywuZXtmaWxsOm5vbmU7fS5ie3N0cm9rZTojMWEyOTViO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MS41cHg7fS5je3N0cm9rZTojZmZiNjU3O3N0cm9rZS13aWR0aDoycHg7fS5ke3N0cm9rZTpub25lO308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYwMCAtNDgpIj48Y2lyY2xlIGNsYXNzPSJhIiBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2MDUgNTMpIi8+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYwNCA1MS41KSI+PHBhdGggY2xhc3M9ImIiIGQ9Ik0xOS40MzYsMjcuMDgxVjI1LjU1NEEzLjIxOCwzLjIxOCwwLDAsMCwxNi4wNzcsMjIuNUg5LjM1OUEzLjIxOCwzLjIxOCwwLDAsMCw2LDI1LjU1NHYxLjUyNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtNy40MTcpIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik0xOC4xMDgsNy41NTRBMy4wNTQsMy4wNTQsMCwxLDEsMTUuMDU0LDQuNSwzLjA1NCwzLjA1NCwwLDAsMSwxOC4xMDgsNy41NTRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi4zMzYgMikiLz48L2c+PGcgY2xhc3M9ImMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2MDAgNDgpIj48Y2lyY2xlIGNsYXNzPSJkIiBjeD0iMTciIGN5PSIxNyIgcj0iMTciLz48Y2lyY2xlIGNsYXNzPSJlIiBjeD0iMTciIGN5PSIxNyIgcj0iMTYiLz48L2c+PC9nPjwvc3ZnPg==";